/* eslint-disable prettier/prettier */
import { createBrowserRouter } from 'react-router-dom';
import LoginPage from '@/pages/LoginPage';
import AuthenticatePage from '@/pages/AuthenticatePage';
import TourBagPage from '@/pages/TourBagPage';
import PlayerPage from '@/pages/PlayerPage';
import { SessionGuard, OfflineQueueGuard } from '@/guard';
import { RouteErrorBoundary } from '@/routes/RouteErrorBoundary';
import BackgroundSyncProviderWrapper from '@/context/BackgroundSyncContext';
import OrdersPage from '@/pages/OrdersPage';
import { isProductionEnv } from '@/utils';

const routes = [
  {
    errorElement: <RouteErrorBoundary />, // global error boundary
    children: [
      {
        path: '/',
        element: <LoginPage />,
      },
      {
        path: '/authenticate',
        element: <AuthenticatePage />,
      },
      {
        element: <SessionGuard />, // applies to all protected routes
        children: [
          {
            element: <OfflineQueueGuard />, // sync offline operations
            children: [
              {
                element: <BackgroundSyncProviderWrapper />, // background data sync
                children: [
                  {
                    path: '/tourbag',
                    element: <TourBagPage />,
                  },
                  {
                    path: '/tourbag/:playerId',
                    element: <PlayerPage />,
                  },
                  ...(!isProductionEnv
                    ? [
                      {
                        path: '/orders',
                        element: <OrdersPage />,
                      },
                    ]
                    : []),
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes, {
  basename: '/apps/tourapp',
});

export default router;
